class ProductDetailsAccordion {
  constructor(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.isAnimating = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.summary.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    if (this.reducedMotion || this.isAnimating) return;

    event.preventDefault();

    if (this.details.open) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isAnimating = true;
    this.details.setAttribute('open', '');
    this.content.style.overflow = 'hidden';
    this.content.style.height = '0px';
    this.content.style.transition = 'height 300ms ease-out';

    window.requestAnimationFrame(() => {
      this.content.style.height = `${this.content.scrollHeight}px`;
    });

    this.content.addEventListener('transitionend', this.onOpenEnd.bind(this), { once: true });
  }

  onOpenEnd() {
    this.content.style.height = '';
    this.content.style.overflow = '';
    this.content.style.transition = '';
    this.isAnimating = false;
  }

  close() {
    this.isAnimating = true;
    this.content.style.overflow = 'hidden';
    this.content.style.height = `${this.content.offsetHeight}px`;
    this.content.style.transition = 'height 300ms ease-out';

    window.requestAnimationFrame(() => {
      this.content.style.height = '0px';
    });

    this.content.addEventListener('transitionend', this.onCloseEnd.bind(this), { once: true });
  }

  onCloseEnd() {
    this.details.removeAttribute('open');
    this.content.style.height = '';
    this.content.style.overflow = '';
    this.content.style.transition = '';
    this.isAnimating = false;
  }
}

function initProductDetailsAccordions(root = document) {
  root.querySelectorAll('.product-details-accordion details').forEach((details) => {
    if (details.dataset.accordionInitialized) return;
    details.dataset.accordionInitialized = 'true';
    new ProductDetailsAccordion(details);
  });
}

document.addEventListener('DOMContentLoaded', () => initProductDetailsAccordions());
document.addEventListener('shopify:section:load', (event) => initProductDetailsAccordions(event.target));
